<div class="delegate-home-container" [ngClass]="{'coach-active': userInfo.is_coaching}" *ngIf="userInfo !== null && userInfo.template !== null">
  <div class="routers" *ngIf="userInfo.is_coaching">
    <div class="route-content" [routerLink]="['/coach/profiles']">
      <div class="icon">
        <img class="profiles-img desktop-only" src="assets/img/footer/coach-profiles-blue.svg" />
        <img class="profiles-img mobile-only" src="assets/img/coach-profiles-blue-mobile.svg" />
      </div>
      <div class="text">{{"__HOME_COACH_PROFILES__" | translate}}</div>
    </div>

    <div  class="route-content" [routerLink]="['/coach/appointments']">
      <div class="coaching-counter">
        <div class="icon">
          <div class="number" *ngIf="progress !== null && progress.coach_appointments.completed > 0">
              {{progress.coach_appointments.completed}}
          </div>
          <img src="assets/img/coach-calendar-main.svg" alt="users" class="my-team desktop-only" />
          <img src="assets/img/coach-calendar-main-mobile.svg" alt="users" class="my-team mobile-only" />
        </div>
      </div>

      <div class="text">{{'__HOME_YOUR_COACHING__' | translate}}</div>
    </div>
  </div>


  <div class="white-group content-wrap desktop-only" (click)="goToJourney()">
    <div class="group-content">
      <div class="small primary-color">
        {{'__HOME_LEARNING_JOURNEY__' | translate}}
      </div>
      <div class="text">{{userInfo.template.name}}</div>
      <div class="date">
        <span class="primary-color">{{'__HOME_START_DATE__' | translate}}</span>
        {{userInfo.template.date_from}}
      </div>
    </div>
      <app-inline-svg class="icon" [file]="'assets/img/blue-forward1.svg'"></app-inline-svg>
  </div>

  <div class="white-group content-wrap mobile-only" (click)="goToJourney()">
    <div class="group-content">
      <div class="text">{{userInfo.template.name}}</div>
        <app-inline-svg class="icon" [file]="'assets/img/blue-forward1.svg'"></app-inline-svg>
    </div>
    <div class="date">
      <span>{{'__HOME_START_DATE__' | translate}}</span>
      {{userInfo.template.date_from}}
    </div>
  </div>


  <div class="white-group content-wrap" *ngIf="userInfo === null || userInfo.template === null  ">
    <div class="no-journey"> {{'__HOME_NO_JOURNEY__' | translate}}</div>
      <app-inline-svg class="icon" [file]="'assets/img/blue-forward1.svg'"></app-inline-svg>
  </div>
</div>
